<template>
	<div class="konwledge-diog-cls" id="konwledgeDiog">
		<!-- Aside Tree -->
		<section class="aside-cls" :class="{'aside-width-cls': isUnfoldAside}" v-loading="treeLoading">
			<Message @EditBigScreenInfo="handleBigScreenInfo" />
			<div class="tabs-cls">
				<div :class="{'active': isResource}" @click.stop="isResource = true;drawerKnowledge = false">资源库</div>
				<div :class="{'active': !isResource}" @click.stop="isResource = false">流程处理</div>
			</div>
			<div class="resource" v-show="isResource">
				<div class="all-resource-cls">
					<svg-icon icon-class="KnowK" />
					<span>全部资源 </span>
					<svg-icon @click.stop="handleUploadTree" icon-class="KnowUpdate" />
					<el-popover
						placement="right-start"
						width="200"
						:disabled="addResourceFlag"
						v-model="visible">
						<p style="font-size: 14px; color: #172B4D;">资源库类型：</p>
						<el-radio-group v-model="resourceType" style="margin: 15px 0;">
							<el-radio label="2">流程库</el-radio>
							<el-radio label="1">知识库</el-radio>
						</el-radio-group>
						<div style="text-align: right;">
							<el-button @click.stop="visible = false" size="mini" type="text" >取消</el-button>
							<el-button @click.stop="handleResourceAdd" type="primary" size="mini">确定</el-button>
						</div>
						<svg-icon v-if="userInfo.userType != '0'" class="zyk-add" slot="reference" icon-class="KnowAddS" />
					</el-popover>
				</div>
				<div class="tree-cls">
					<el-tree 
						ref="tree" 
						node-key="id" 
						icon-class="el-icon-arrow-right"
						draggable
						:allow-drop="allowDrop"
						@node-drop="treeSort"
						:highlight-current="true" 
						:current-node-key="currentNodeKey"
						:default-expanded-keys="defaultExpandedKeys"
						:load="loadTreeNode" 
						:props="defaultProps" 
						:expand-on-click-node="false"
						@node-click="handleTreeClick"
						lazy>
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<div class="container-cls">
								<div v-if="userInfo.userType != '0' || data.right == 6" v-show="data.isEdit && addTreeFlag" class="add-resource-cls">
									<el-input @click.stop.native v-model="data.name" @keyup.enter.native="handleTouchInTree(node, data)" placeholder="请输入名称" maxlength="20" show-word-limit size="mini"></el-input>
									<svg-icon @click.stop="handleTouchInTreeClose(node, data)" icon-class="KnowClose" />
									<svg-icon @click.stop="handleTouchInTree(node, data)" @keyup.enter.native="handleTouchInTree(node, data)" icon-class="KnowDG" />
								</div>
								<div v-show="!data.isEdit" class="label-cls">
									<svg-icon v-if="node.level === 1" :icon-class="data.type == '1' ? 'KnowArticle' : 'KnowProcess'" />
									<span v-if="node.level === 1"> {{ node.label }}</span>
									<span v-if="node.level !== 1 && !data.isEdit"> {{ node.label }} [ {{data.qaNum}} ]</span>
								</div>
								<div v-if="userInfo.userType != '0' || data.right == 6" v-show="!data.isEdit" class="cell">
									<svg-icon v-show="node.level < 7" @click.stop="handleCommand('add', node, data)" icon-class="KnowAdd" />
									<el-dropdown @click.stop.native @command="(res) => { return handleCommand(res, node, data)}" trigger="click" placement="bottom-start">
										<i><svg-icon icon-class="KnowMore" /></i>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item @click.stop.native command="rename">重命名</el-dropdown-item>
											<el-dropdown-item v-if="node.level > 1" @click.stop.native command="delete">删除</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
							</div>
						</span>
					</el-tree>
					<div class="add-resource-cls" v-show="addResourceFlag">
						<el-input v-model="resourceName" ref="resourceName" @keyup.enter.native="handleTouchInResource" size="mini" placeholder="请输入资源库名称" maxlength="20" show-word-limit clearable></el-input>
						<svg-icon @click.stop="addResourceFlag = false;" icon-class="KnowClose22" />
						<svg-icon @click.stop="handleTouchInResource" icon-class="KnowDG" />
					</div>
				</div>
			</div>
			<div class="overall" v-show="!isResource">
				<SessionTabs @sessionEmitClose="sessionEmitClose" @sessionKnowInfo="sessionKnowInfo" />
			</div>
		</section>

		<!-- Main Container -->
		<section class="main-cls" :class="{'main-width-cls': isUnfoldAside}">
			<!-- Main New Carousel -->
			<div class="main-carousel-cls">
				<svg-icon @click.stop="isUnfoldAside = !isUnfoldAside;" icon-class="KnowUnfold" />
				<div>
					<MainCarousel @EditBigScreenInfo="handleBigScreenInfo" />
				</div>
			</div>

			<!-- Main Search -->
			<div class="main-search-cls">
				<svg-icon icon-class="Knowjqr" />
				<el-autocomplete
					v-model="searchQuery.search"
					:fetch-suggestions="querySearchAsync"
					:trigger-on-focus="false"
					@keyup.enter.native="handleSearch"
					placeholder="请输入内容"
					size="medium"
					clearable 
					@select="handleSelect">
					<i @click="handleSearch" class="el-icon-search el-input__icon" slot="suffix" style="cursor: pointer;"></i>
					<template slot-scope="{ item }">
						<div class="name" v-html="item.value"></div>
					</template>
				</el-autocomplete>
			</div>

			<!-- Main Switch -->
			<div class="main-search-switch-cls">
				<!-- <el-radio-group v-model="searchQuery.isAll">
					<el-radio :label="false">智能</el-radio>
					<el-radio :label="true">全文</el-radio>
				</el-radio-group>
				<el-divider direction="vertical"></el-divider> -->
				<el-select v-model="searchQuery.types" size="mini" placeholder="全部" class="a">
					<el-option
						v-for="item in [{id: '1', name: '知识'}, {id: '2', name: '流程'}]"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="searchQuery.resourceIdsTem" size="mini" placeholder="请选择" filterable multiple collapse-tags clearable class="b">
					<el-option
						v-for="item in resourceList"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
				<el-dropdown @command="handleBatchCommand" size="small" split-button type="primary" trigger="click" placement="bottom-start" v-if="currentNode.type == '1' && currentNode.level == 1 && (userInfo.userType != '0' || currentNode.right == 6)">
					<el-upload
						:http-request="httpRequestFile"
						:show-file-list="false"
						accept=".xlsx, .xls"
						action="">
						<span style="color: #ffffff;">批量上传</span>
					</el-upload>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="download">下载模板</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<el-button v-if="currentNode.level > 1 && (userInfo.userType != '0' || currentNode.right == 6)" @click.stop="handleKnowTouchIn('create')" size="mini" type="primary">新增{{currentNode.type == '2' ? '流程' : '知识'}}</el-button>
			</div>

			<!-- Main Breadcrumb -->
			<div class="main-breadcrumb-cls">
				<span>
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-for="(item, index) in currentNodeNameList" :key="index">{{item.name}}</el-breadcrumb-item>
					</el-breadcrumb>
				</span>
				<!-- <el-dropdown>
					<span>
						近7天点击<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="今天点击">今天点击</el-dropdown-item>
						<el-dropdown-item command="近3天点击">近3天点击</el-dropdown-item>
						<el-dropdown-item command="近7天点击">近7天点击</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown> -->
			</div>

			<!-- Main List -->
			<div class="main-list-cls" ref="listBox" v-loading="loading">
				<template v-if="listQuery.type == '2'">
					<div @click.stop="handleBigScreenInfo(item.id)" class="process-cell-cls" v-for="(item, index) in list" :key="index">
						<div class="title-cls">
							<svg-icon icon-class="KnowProcess" />
							<span v-html="item.q"></span>
							<i v-if="item.hot">Hot</i>
						</div>
						<div class="btns-cls">
							<span v-if="userInfo.userType != '0' || currentNode.right == 6" class="status-cls" :class="{'active': item.status == '1'}">{{item.status == '1' ? '已生效' : '未生效'}}</span>
							<span class="click-cls">查看量：<i>{{item.click}}</i></span>
							<svg-icon v-if="userInfo.userType != '0' || currentNode.right == 6" @click.stop="handleKnowTouchIn('update', item)" icon-class="KnowEdit" />
							<svg-icon v-if="userInfo.userType != '0' || currentNode.right == 6" @click.stop="handleDeleteQA(item)" icon-class="KnowDelete" />
							<!-- <el-dropdown @click.stop.native @command="(res) => { return handleCommand(res, node, data)}" trigger="click" placement="bottom-start">
								<i><svg-icon icon-class="KnowMore" /></i>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.stop.native command="rename">重命名</el-dropdown-item>
									<el-dropdown-item @click.stop.native command="delete">删除</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown> -->
						</div>
					</div>
				</template>
				<template v-else>
					<div @click.stop="handleBigScreenInfo(item.id)" class="know-cell-cls" v-for="(item, index) in list" :key="index">
						<div class="header-cls">
							<div class="title-cls">
								<svg-icon icon-class="KnowArticle" />
								<span>Q： <span v-html="item.q"></span></span>
								<i v-if="item.hot">Hot</i>
							</div>
							<div class="btns-cls">
								<span v-if="userInfo.userType != '0' || currentNode.right == 6" class="status-cls" :class="{'active': item.status == '1'}">{{item.status == '1' ? '已生效' : '未生效'}}</span>
								<span class="click-cls">查看量：<i>{{item.click}}</i></span>
								<svg-icon v-if="userInfo.userType != '0' || currentNode.right == 6" @click.stop="handleKnowTouchIn('update', item)" icon-class="KnowEdit" />
								<svg-icon v-if="userInfo.userType != '0' || currentNode.right == 6" @click.stop="handleDeleteQA(item)" icon-class="KnowDelete" />
								<!-- <svg-icon icon-class="KnowZK" /> -->
							</div>
						</div>
						<div class="describe-cls" v-html="item.ashort"></div>
					</div>
				</template>
				<el-empty v-if="list.length === 0" description="暂无数据"></el-empty>
				<div class="pagination-cls" v-show="total > 0">
					<el-pagination
						:current-page.sync="listQuery.pageNum"
						:page-size.sync="listQuery.pageSize"
						:total="total"
						@current-change="handleCurrentChange"
						layout="total, prev, pager, next, jumper"
						background>
					</el-pagination>
				</div>
			</div>
		</section>
		<el-drawer
			size="60%"
			:visible.sync="drawerTouchIn"
			:modal-append-to-body="false"
			:close-on-press-escape="false"
			:wrapperClosable="false"
			:withHeader="false">
			<TouchIn v-if="drawerTouchIn" :currentNode="currentNode" :drawerType="drawerType" :qaId="qaId" :currentNodeNameList="currentNodeNameList" @drawerTouchInClose="drawerTouchInClose" />
		</el-drawer>

		<section v-show="drawerKnowledge" class="modal-frame-cls" :class="{'main-width-cls': isUnfoldAside}">
			<KnowInfo @emitUnfoldAside="isUnfoldAside = !isUnfoldAside;" :cell="cell" :currentNode="currentNode" @drawerKnowInfoClose="handleCloseKnowInfo" />
		</section>

		<!-- 弹出dialog大图 -->
		<el-dialog title="查看图片" :modal-append-to-body="false" @close="handleDialogClose" :close-on-press-escape="false" :wrapperClosable="false" :visible.sync="isDiagShow" class="imgView-dialog">
			<div class="main">
				<img class="img" width="100%" :src="StoreImageView" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { generateUUID } from 'utils/index';
import MainCarousel from './components/MainCarousel';
import KnowInfo from './KnowInfo/index';
import SessionTabs from './components/SessionTabs';
import TouchIn from './components/TouchIn';
import Message from './components/Message';
export default {
	name: 'KnowledgePage',
	computed: {
		...mapGetters([
			'userInfo',
			'StoreImageView',
			'StoreIsImageView'
		])
	},
	watch: {
		StoreIsImageView: {
			handler(val) {
				this.isDiagShow = val;
			},
			immediate: true,
			deep: true
		},
		currentNodeKey(id) {
			if (id.toString()) {
				this.$refs["tree"].setCurrentKey(id);
			} else {
				this.$refs["tree"].setCurrentKey(null);
			}
		},
		$route: {
			handler(val){
				if(val?.query?.EditBigScreenInfo) {
					this.handleBigScreenInfo(this.$route?.query?.EditBigScreenInfo);
				} 
			},
			immediate: true,
			deep: true
		},
		'searchQuery.types': {
			handler(){
				this.searchQuery.resourceIdsTem = '';
				this.getResourceList();
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		return {
			isDiagShow: false,
			isResource: true,
			treeLoading: false,
			drawerTouchIn: false,
			drawerType: 'create',
			qaId: '',
			drawerKnowledge: false,
			qaDetail: {},
			isUnfoldAside: true,
			currentNodeKey: '',
			defaultExpandedKeys: [],
			currentNodeNameList: [],
			defaultProps: {
				children: 'children',
				label: 'name',
				isLeaf: 'leaf'
			},
			searchQuery: {
				search: '',
				isAll: true,
				projectId: '',
				resourceIds: '',
				resourceIdsTem: '',
				types: ''
			},
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				type: '',
				projectId: '',
				resourceIds: '',
				treeId: '',
				status: ''
			},
			list: [],
			total: 0,
			loading: false,
			currentNode: {},
			visible: false,
			resourceType: '2',
			resourceName: '',
			addResourceFlag: false,
			addTreeFlag: false,
			command: '',
			node: null,
			TreeNode: null,
			cell: null,
			resourceList: []
		}
	},
	methods: {
		...mapMutations({
			'SET_SESSION_LIST_ADD': 'knowService/SET_SESSION_LIST_ADD',
			'SET_SESSION_CURRENT_NODE': 'knowService/SET_SESSION_CURRENT_NODE',
			'SET_IMAGE_VIEW': 'knowService/SET_IMAGE_VIEW'
		}),
		httpRequestFile (file) {
			const formData = new FormData();
			formData.append('file', file.file);
			formData.append('projectId', this.userInfo.brandIdentify);
			formData.append('resourceId', this.currentNode.resourceId);
			this.$api.apiPostKnowledgeBatchImportQa(formData).then(response => {
				if(response.errcode != 0) return;
				this.getList(this.currentNode);
				this.handleUploadTree();
			});
		},
		handleBatchCommand(command) {
			let $a = document.createElement('a');
			$a.setAttribute("href", `${window.location.origin}/assistant/static/templates/QAExcelTemplatesTree.xlsx`);
			$a.setAttribute("download", '知识导入模板.xlsx');
			$a.setAttribute("target", "_parent");
			let evObj = document.createEvent('MouseEvents');
			evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			$a.dispatchEvent(evObj);
		},

		handleDialogClose() {
			this.SET_IMAGE_VIEW({
				url: '',
				isShow: false
			});
		},
		handleCloseKnowInfo(update) {
			if(update) {
				this.handleKnowTouchIn('update', {id: update})
			}
			this.drawerKnowledge = false;
		},
		allowDrop(draggingNode, dropNode, type) {
			if (draggingNode.level === dropNode.level) {
				if (draggingNode.parent.id === dropNode.parent.id) {
					return type === "prev" || type === "next";
				}
			} else {
				return false;
			}
		},
		treeSort(draggingNode, dropNode) {
			let array = [];
			for (let i = 0; i < dropNode.parent.childNodes.length; i++) {
				array.push([dropNode.parent.childNodes[i].data.id, i+1]);
			}
			if(draggingNode.level === 1) {
				this.$api.apiPostKnowledgeResourceSort({sorts: array});
			} else {
				this.$api.apiPostKnowledgeTreeSort({sorts: array});
			}
		},
		handleDeleteQA(item) {
			this.$confirm(`是否删除此${item.type == '1' ? '知识' : '流程'}？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$api.apiPostKnowledgeQaDelete({
					projectId: item.projectId,
					id: item.id
				}).then(response => {
					if(response.errcode != 0) return;
					this.getList(this.currentNode);
					this.$message.success("删除成功！");
				});
			});
		},
		handleBigScreenInfo(id) {
			this.$api.apiPostKnowledgeQAInfo({projectId: this.userInfo.brandIdentify, id: id}).then(response => {
				if(response.errcode != 0) return;
				this.cell = response.data;
				this.cell['uuid'] = generateUUID();
				this.cell['createAt'] = dayjs(new Date()).format('HH:mm');
				this.cell.a = JSON.parse(this.cell.a);
				
				if(this.cell.type == '2') {
					this.$set(this.cell?.a?.themeList[0], "isSummary", true);
					this.$set(this.cell?.a, "themeListTem", []);
					this.cell?.a['themeListTem'].push(this.cell?.a?.themeList[0]);
					this.$set(this.cell?.a, "aId", this.cell?.a?.themeListTem[0]?.['id']);
					this.SET_SESSION_LIST_ADD(this.cell);
					this.isResource = false;
				} else {
					this.SET_SESSION_CURRENT_NODE(this.cell);
				}
				this.drawerKnowledge = true;
			});
		},
		sessionKnowInfo(item) {
			item['a'] = Math.random();
			this.cell = item;
			this.drawerKnowledge = true;
		},
		sessionEmitClose() {
			this.drawerKnowledge = false;
		},
		handleKnowTouchIn(type, item) {
			if(type === 'update') {
				this.qaId = item.id;
			} 
			this.drawerTouchIn = true;
			this.drawerType = type;
		},
		handleSelect() {
			this.searchQuery.search = this.searchQuery.search.replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
			this.handleSearch();
		},
		handleCommand(command, node, data) {
			this.command = command;
			this.node = node;
			switch(command) {
				case 'add': {
					if(this.addTreeFlag) {
						this.$message.error('请先新增完再添加');
						return;
					}
					data.children.push({
						id: null,
						projectId: data.projectId,
						resourceId: data.resourceId,
						treeId: null,
						parentId: data.level === 1 ? null : data.id,
						type: data.type,
						name: '新分组',
						children: [],
						level: data.level + 1,
						right: 6,
						isEdit: true,
						qaNum: 0,
						leaf: true
					});
					this.$refs.tree.store.nodesMap[data.id].expanded = true;
					this.addTreeFlag = true;
					break;
				}
				case 'rename': {
					if(this.addTreeFlag) return;
					this.addTreeFlag = true;
					data.isEdit = true;
					break;
				}
				case 'delete': {
					this.$confirm("是否删除此节点？","系统提示",{
						confirmButtonText: "确认",
						cancelButtonText: "取消",
						type: "warning"
					}).then(() => {
						let DeleteOpr = () => {
							this.$nextTick(() => {
								if(this.$refs.tree) {
									this.$refs.tree.remove(data);
									this.$message.success("删除成功！");
								}
							});
						}
						if(data.level === 1) {
							this.$api.apiPostKnowledgeDeleteResourceEntity({
								projectId: data.projectId,
								id: data.id
							}).then(response => {
								if(response.errcode != 0) return;
								DeleteOpr();
							});
						} else {
							this.$api.apiPostKnowledgeDeleteTreeEntity({
								projectId: data.projectId,
								id: data.id
							}).then(response => {
								if(response.errcode != 0) return;
								DeleteOpr();
							});
						}
					});
					break;
				}
			}
		},
		handleTouchInTree(node, data) {
			const self = this;
			if(!(/^(?!_)(?!-)(?!.*?_$)(?!.*?-$)[a-zA-Z0-9-_\u4e00-\u9fa5\\s·]+$/.test(data.name))) {
				this.$message.error('仅支持中文、英文和数字');
				return;
			}
			switch(self.command) {
				case 'add': {
					self.$api.apiPostKnowledgeAddTreeEntity({
						projectId: data.projectId,
						resourceId: data.resourceId,
						parentId: data.parentId ? data.parentId : null,
						name: data.name
					}).then(response => {
						if(response.errcode != 0) return;
							data.id = response.data?.id;
							data.isEdit = false;
							self.addTreeFlag = false;
							self.node.parent.loaded = false;
							self.node.parent.expand();
						
					});
					break;
				}
				case 'rename': {
					if(data.level === 1) {
						this.$api.apiPostKnowledgeEditResourceEntity({
							projectId: data.projectId,
							id: data.id,
							name: data.name
						}).then(response => {
							if(response.errcode != 0) return;
							self.addTreeFlag = false;
							data.isEdit = false;
						});
					} else {
						self.$api.apiPostKnowledgeEditTreeEntity({
							projectId: data.projectId,
							id: data.id,
							name: data.name
						}).then(response => {
							if(response.errcode != 0) return;
							self.addTreeFlag = false;
							data.isEdit = false;
						});
					}
					break;
				}
			}
		},
		handleTouchInTreeClose(node, data) {
			if(this.command === 'add') {
				this.$refs.tree.remove(data);
			} else {
				if(data.id) {
					data.isEdit = false;
				} else {
					this.$refs.tree.remove(data);
				}
			}
			this.addTreeFlag = false;
		},
		handleResourceAdd() {
			this.visible = false;
			this.addResourceFlag = true;
			this.resourceName = '';
			setTimeout(() => {
				this.$refs.resourceName.focus();
			}, 100);
		},
		handleTouchInResource() {
			if(!this.resourceName) {
				this.$message.error('资源库名称不能为空');
				return;
			}
			if(!(/^(?!_)(?!-)(?!.*?_$)(?!.*?-$)[a-zA-Z0-9-_\u4e00-\u9fa5\\s·]+$/.test(this.resourceName))) {
				this.$message.error('仅支持中文、英文和数字');
				return;
			}
			this.$api.apiPostKnowledgeAddResourceEntity({
				name: this.resourceName,
				projectId: this.userInfo.brandIdentify,
				type: this.resourceType
			}).then(response => {
				if(response.errcode != 0) return;
				const data = response.data;
				this.$refs.tree.append({
					id: data.id,
					projectId: data.projectId,
					resourceId: data.id,
					treeId: null,
					parentId: null,
					type: data.type,
					name: data.name,
					children: [],
					level: 1,
					isEdit: false
				});
				this.addResourceFlag = false;
			});
		},
		loadTreeNode(node, resolve) {
			const self = this;
			if(!self.TreeNode) {
				self.TreeNode = node;
			}
			resolve([]);
			if (node.level === 0) {
				self.$api.apiPostKnowledgeResourceJWTByList().then(response => {
					if(response.errcode != 0) {
						resolve([]);
						return;
					}
					self.resourceList = [];
					if(response?.data && response?.data?.length > 0) {
						let array = [];
						for(const item of response.data) {
							array.push({
								id: item.id,
								projectId: item.projectId,
								resourceId: item.id,
								treeId: null,
								parentId: null,
								type: item.type,
								name: item.name,
								children: [],
								level: node.level + 1,
								isEdit: false,
								right: item.right
							});
						}
						self.currentNodeNameList = [{name: array[0].name}];
						self.defaultExpandedKeys = [array[0].id];
						self.currentNodeKey = array[0].id;
						self.handleTreeClick(array[0]);
						self.searchQuery.types = array[0].type;
						// self.searchQuery.resourceId = [array[0].id];
						for(const item of response.data) {
							if(self.searchQuery.types == item.type) {
								self.resourceList.push(item);
							}
						}
						return resolve(array);
					} else {
						resolve([]);
					}
					self.treeLoading = false;
				});
				// self.$api.apiPostKnowledgeResourceByList({
				// 	projectId: self.userInfo.brandIdentify
				// }).then(response => {
				// 	if(response.errcode != 0) {
				// 		resolve([]);
				// 		return;
				// 	}
				// 	if(response?.data && response?.data?.length > 0) {
				// 		let array = [];
				// 		for(const item of response.data) {
				// 			array.push({
				// 				id: item.id,
				// 				projectId: item.projectId,
				// 				resourceId: item.id,
				// 				treeId: null,
				// 				parentId: null,
				// 				type: item.type,
				// 				name: item.name,
				// 				children: [],
				// 				level: node.level + 1,
				// 				isEdit: false
				// 			});
				// 		}
				// 		self.currentNodeNameList = [{name: array[0].name}];
				// 		self.defaultExpandedKeys = [array[0].id];
				// 		self.currentNodeKey = array[0].id;
				// 		self.handleTreeClick(array[0]);
				// 		return resolve(array);
				// 	} else {
				// 		resolve([]);
				// 	}
				// 	self.treeLoading = false;
				// });
			} else if(node.level === 1) {
				self.$api.apiPostKnowledgeSelectTreeList({
					projectId: node.data.projectId,
					resourceId: node.data.resourceId
				}).then(response => {
					if(response.errcode != 0) {
						resolve([]);
						return;
					}
					let array = [];
					for(const item of response.data) {
						array.push({
							id: item.id,
							projectId: item.projectId,
							resourceId: item.resourceId,
							parentId: null,
							treeId: item.id,
							type: node.data.type,
							name: item.name,
							leaf: item.childNum === 0 ? true : false,
							qaNum: item.qaNum,
							children: [],
							level: node.level + 1,
							isEdit: false,
							right: node.data.right
						});
					}
					self.treeLoading = false;
					return resolve(array);
				});
			} else {
				self.$api.apiPostKnowledgeSelectTreeList({
					projectId: node.data.projectId,
					resourceId: node.data.resourceId,
					parentId: node.data.treeId
				}).then(response => {
					if(response.errcode != 0) {
						resolve([]);
						return;
					}
					let array = [];
					for(const item of response.data) {
						array.push({
							id: item.id,
							projectId: item.projectId,
							resourceId: item.resourceId,
							parentId: node.data.treeId,
							treeId: item.id,
							type: node.data.type,
							name: item.name,
							leaf: item.childNum === 0 ? true : false,
							qaNum: item.qaNum,
							children: [],
							level: node.level + 1,
							isEdit: false,
							right: node.data.right
						});
					}
					self.treeLoading = false;
					return resolve(array);
				});
			}
		},
		handleTreeClick(data, node) {
			// this.;
			// this.SET_SESSION_CURRENT_NODE('');
			this.addTreeFlag = false;
			this.drawerKnowledge = false;
			if(!data.id) return;
			this.currentNodeKey = data.id;
			if(data.level == 1) {
				this.currentNodeNameList = [data];
				this.defaultExpandedKeys = [data.id];
			}
			if(data.level > 1) {
				this.currentNodeNameList = [];
				this.defaultExpandedKeys = [];
				this.getTreeNode(this.$refs.tree.getNode(node.key));
			}
			this.getList(data);
			this.searchQuery.types = data.type;
		},
		getList(data) {
			this.currentNode = data;
			this.loading = true;
			this.listQuery.projectId = data.projectId;
			this.listQuery.resourceId = data.resourceId;
			this.listQuery.treeId = data.treeId;
			this.listQuery.type = data.type;
			this.listQuery.status = (this.userInfo.userType != '0' || this.currentNode.right == 6) ? '' : '1';
			data.type == '2' ? this.listQuery.pageSize = 10 : this.listQuery.pageSize = 5;
			this.$api.apiPostKnowledgeQAList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.list = [];
					this.total = 0;
					this.loading = false;
					return;
				}
				if(response?.data && response.data?.rows) {
					this.list = response?.data?.rows;
					this.total = response.data?.total;
					for(const item of this.list) {
						item['isHelp'] = false;
						item['helpType'] = '';
					}
				} else {
					this.list = [];
					this.total = 0;
				}
				this.loading = false;
			});
		},
		handleUploadTree() {
			this.treeLoading = true;
			this.TreeNode.loaded = false;
			this.TreeNode.expand(); 
		},
		handleSearch() {
			if(!this.currentNode.resourceId && !this.searchQuery.resourceIdsTem) return;
			if(!this.searchQuery.search && !this.searchQuery.resourceIdsTem) {
				this.getList(this.currentNode);
				// this.$message.error('请输入要搜索的内容');
				return;
			}
			this.loading = true;
			this.searchQuery.projectId = this.currentNode.projectId;
			this.searchQuery.resourceIdsTem.length === 0 ? this.searchQuery.resourceIds = this.currentNode.resourceId : this.searchQuery.resourceIds = this.searchQuery.resourceIdsTem;
			// this.searchQuery.treeId = this.currentNode.treeId;
			if(this.searchQuery.isAll) {
				// this.searchQuery.types = this.currentNode.type;
				this.$api.apiPostKnowledgeSearchAll(this.searchQuery).then(response => {
					if(response.errcode != 0 || !response.data) {
						this.list = [];
						this.total = 0;
						this.loading = false;
						return;
					}
					this.list = response?.data;
					for(const item of this.list) {
						item['isHelp'] = false;
						item['helpType'] = '';
						item['ashort'] = item['a'];
						item['q'] = item['q'].replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
					}
					// this.total = this.list?.length;
					this.total = 0;
					this.loading = false;
				});
			} else {
				this.$api.apiPostKnowledgeSearchIntelligent(this.searchQuery).then(response => {
					if(response.errcode != 0 || !response.data) {
						this.list = [];
						this.total = 0;
						this.loading = false;
						return;
					}
					this.list = response?.data;
					for(const item of this.list) {
						item['isHelp'] = false;
						item['helpType'] = '';
						item['ashort'] = item['a'];
						item['q'] = item['q'].replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
					}
					// this.total = this.list?.length;
					this.total = 0;
					this.loading = false;
				});
			}
		},
		getTreeNode(node){ 
            if (node) {
                if (node.label !== undefined) {
					this.currentNodeNameList.unshift(node.data);
					this.defaultExpandedKeys.unshift(node.key);
                    this.getTreeNode(node.parent);
                }
            }
        },
		handleCurrentChange(val) {
			this.listQuery.pageNum = val;
			this.getList(this.currentNode);
		},
		querySearchAsync(queryString, cb) {
			const self = this;
			if(queryString && this.currentNode.resourceId) {
				self.$api.apiPostKnowledgeSelectQAByKeyWord({
					KeyWord: queryString,
					projectId: self.userInfo.brandIdentify,
					resourceIds: self.searchQuery.resourceIdsTem.length == 0 ? self.currentNode.resourceId : self.searchQuery.resourceIdsTem,
					// treeId: self.currentNode.treeId,
					type: self.currentNode.type
				}).then(response => {
					if(response.errcode != 0) return;
					let restaurants = response.data ? response.data : [];
					for(const item of restaurants) {
						item['value'] = item.q;
					}
					cb(restaurants);
				});
			} else {
				cb([]);
			}
		},
		drawerTouchInClose(isUpdate) {
			this.drawerTouchIn = false;
			if(isUpdate){
				// this.handleUploadTree();
				this.getList(this.currentNode);
			} 
		},
		getResourceList() {
			this.resourceList = [];
			this.$api.apiPostKnowledgeResourceJWTByList().then(response => {
				if(response.errcode != 0) return;
				for(const item of response.data) {
					if(this.searchQuery.types == item.type) {
						this.resourceList.push(item);
					}
				}
			});
		}
	},
	components: {
		MainCarousel,
		KnowInfo,
		TouchIn,
		SessionTabs,
		Message
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-tree-node__label {
	font-weight: bold;
}

::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #E6E9EF;
}

::v-deep .el-drawer__header {
	margin-bottom: 20px;
}

::v-deep .el-select.a input {
	width: 70px;
	background: #f5f7fa;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	border-right: none;
}

::v-deep .el-select.b input {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.konwledge-diog-cls {
	width: 100%;
	height: 100%;
	background: #FFF;
	box-sizing: border-box;
	position: relative;

	& > .aside-cls, & > .main-cls {
		height: 100%;
		display: inline-block;
		vertical-align: top;
		box-sizing: border-box;
	}

	& > .aside-cls {
		width: 0;
		height: 100%;
		user-select: none;
		-webkit-user-drag: none;
		overflow: hidden;
		transition: width .2s;

		&.aside-width-cls {
			width: 300px;
		}

		& > .tabs-cls {
			width: 100%;
			height: 45px;
			border-bottom: solid 1px #dcdfe6;
			box-sizing: border-box;
			line-height: 45px;


			& > div {
				width: 50%;
				line-height: 43px;
				text-align: center;
				font-size: 14px;
				font-weight: 500;
				color: #A6AAB8;
				display: inline-block;
				vertical-align: top;
				box-sizing: border-box;
				cursor: pointer;

				&.active {
					color: #337EFF;
					border-bottom: solid 2px #337EFF;
				}
			}
		}

		& > .resource {
			height: 100%;
			& > .all-resource-cls {
				width: 100%;
				height: 40px;
				padding: 0 20px;
				box-sizing: border-box;
				line-height: 40px;

				& > span {
					font-size: 14px;
					font-weight: 400;
					color: #337EFF;
					font-weight: bold;
				}

				& > .svg-icon {
					font-size: 14px;
					font-weight: 400;
					color: #337EFF;
					margin-right: 8px;
					font-weight: bold;

					&:nth-of-type(2) {
						cursor: pointer;
						margin-left: 5px;
						color: #566980;
					}
				}

				& .zyk-add {
					outline:none;
					float: right;
					font-size: 16px;
					position: relative;
					top: 13px;
					right: -6px;
					cursor: pointer;
					color: #566980;
				}
			}

			& > .tree-cls {
				width: 100%;
				padding: 0 15px 20px 18px;
				box-sizing: border-box;
				height: calc(100% - 130px);
				overflow-x: hidden;
				overflow-y: auto;

				& .el-tree {
					background: transparent;

					& .custom-tree-node {
						width: 100%;
						font-size: 14px;

						& > .container-cls {
							width: 100%;
							height: 100%;
							vertical-align: top;
							overflow: hidden;

							& .add-resource-cls {
								width: 100%;
								height: 25px;
								& > .svg-icon {
									margin-left: 10px;
									float: right;
									margin-top: 6px;
									color: #337EFF;
									cursor: pointer;

									&:nth-of-type(1) {
										color: #5A5A68;
									}
								}

								::v-deep .el-input {
									height: 25px !important;
									line-height: 25px !important;
									width: calc(100% - 52px);
								}

								::v-deep .el-input input {
									height: 25px !important;
									line-height: 25px !important;
								}
							}

							& .label-cls {
								display: inline-block;
								vertical-align: top;
								width: calc(100% - 50px);
								overflow:hidden;
								text-overflow:ellipsis;
								white-space:nowrap;
								font-weight: bold;
								color: #606266;
							}

							& .cell {
								display: none;
								vertical-align: top;
								float: right;
								width: 50px;
								height: 20px;
								text-align: right;
								line-height: 20px;

								& .svg-icon {
									margin-left: 8px;
									font-size: 14px;
									color: #566980;
									cursor: pointer;
								}
							}

							&:hover {
								& .cell {
									display: inline-block;
								}
							}
						}
					}
				}

				& .add-resource-cls {
					width: 100%;
					height: 28px;
					& > .el-input {
						width: calc(100% - 52px);
					}

					& > .svg-icon {
						margin-left: 10px;
						float: right;
						margin-top: 6px;
						color: #337EFF;
						cursor: pointer;

						&:nth-of-type(1) {
							color: #5A5A68;
							font-size: 14px;
						}
					}

					::v-deep .el-input {
						height: 25px !important;
						line-height: 25px !important;
						width: calc(100% - 52px);
					}

					::v-deep .el-input input {
						height: 25px !important;
						line-height: 25px !important;
					}
				}
			}
		}

		& > .overall {
			width: 100%;
			height: calc(100% - 45px - 45px);
			overflow-x: hidden;
			overflow-y: auto;

			& > .cell {
				width: 100%;
				height: 60px;
				padding: 0 20px;
				box-sizing: border-box;

				&.active, &:hover {
					background: #E6E9EF;
				}

				& > .item {
					width: 100%;
					height: 100%;
					border-bottom: 1px solid #D8D8D8;
					padding: 9px 0;
					box-sizing: border-box;
					cursor: pointer;

					&:hover {
						& > .top > .svg-icon:nth-of-type(2) {
							display: inline-block;
						}
					}

					& > div {
						width: 100%;
						line-height: 20px;
						margin-top: 2px;
						font-size: 14px;
						font-weight: 400;
						color: #337EFF;
						line-height: 20px;

						&.top {
							margin-top: 0;

							& > .svg-icon {
								font-size: 14px;
								margin-right: 6px;
								vertical-align: top;
								position: relative;
								top: 3px;

								&:nth-of-type(2) {
									display: none;
									float: right;
									cursor: pointer;
								}
							}

							& > span {
								display: inline-block;
								width: 200px;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						}

						&.bottom {
							width: 200px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							color: #A6AAB8;
							padding-left: 20px;
							box-sizing: border-box;
						}
					}
				}
			}
		}
	}

	& > .main-cls {
		width: 100%;
		overflow: hidden;
		transition: width .2s;
		border: none;
		border-left: solid 1px#dcdfe6;

		&.main-width-cls {
			width: calc(100% - 300px);
			border-left: solid 1px #dcdfe6;
		}

		& > .main-carousel-cls {
			width: 100%;
			height: 45px;
			background: #F3F3F3;
			margin-bottom: 20px;
			padding-left: 10px;
			box-sizing: border-box;

			& > .svg-icon {
				font-size: 18px;
				color: #566980;
				cursor: pointer;
				display: inline-block;
				vertical-align: top;
				margin-right: 10px;
				margin-top: 14px;
			}
			& > div {
				display: inline-block;
				vertical-align: top;
				width: calc(100% - 50px);
			}

			::v-deep .el-carousel__arrow  {
				width: 16px;
				height: 16px;
				background: #DEDFDF;

				& i {
					color: #A6AAB8;
					font-weight: bold;
				}
			}

			& .container-cls {
				width: 500px;
				height: 100%;
				margin: 0 auto;

				& > .cell {
					display: inline-block;
					vertical-align: top;
					width: 50%;
					height: 100%;
					padding: 13.5px 0;
					box-sizing: border-box;
					text-align: center;

					& > i {
						vertical-align: top;
						width: 38px;
						height: 18px;
						background: #47B267;
						border-radius: 18px;
						display: inline-block;
						font-style: normal;
						font-size: 11px;
						color: #fff;
						text-align: center;
						line-height: 18px;
						margin-right: 3px;
						cursor: pointer;
					}

					& > span {
						vertical-align: top;
						font-size: 12px;
						font-weight: 400;
						color: #3C4353;
						cursor: pointer;
					}
				}
			}
		}

		& > .main-search-cls {
			width: 100%;
			height: 36px;
			padding: 0 20px;
			box-sizing: border-box;
			margin-bottom: 9px;

			& > .svg-icon {
				font-size: 28px;
				margin-right: 8px;
				line-height: 36px;
				vertical-align: top;
				margin-top: 2px;
				float: left;
			}

			& > .el-input, & > .el-autocomplete {
				width: calc(100% - 36px);
				vertical-align: top;
			}
		}

		& > .main-search-switch-cls {
			width: 100%;
			height: 28px;
			padding: 0 20px 0 55px;
			box-sizing: border-box;
			line-height: 28px;
			margin-bottom: 12px;

			& .el-dropdown {
				float: right;
				margin-left: 10px;
				position: relative;
				top: -1px;
			}

			& .el-button {
				float: right;
				margin-left: 10px;
			}
		}

		& > .main-breadcrumb-cls {
			width: 100%;
			height: 24px;
			padding: 0 20px;
			box-sizing: border-box;
			margin-bottom: 18px;
			
			& > span {
				width: calc(100% - 100px);
				display: inline-block;
				vertical-align: top;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;

				::v-deep .el-breadcrumb span{
					font-size: 14px;
					font-weight: 900 !important;
					color: #606266;
					line-height: 24px;
				}
			}

			& .el-dropdown {
				float: right;
				line-height: 24px;
				font-size: 12px;
				color: #6C7E91;
			}
		}

		& > .main-tabs-cls {
			width: 100%;
			height: 36px;
			padding: 0 20px;
			box-sizing: border-box;
			margin-bottom: 9px;

			& > span {
				display: inline-block;
				vertical-align: top;
				width: 50%;
				line-height: 34px;
				text-align: center;
				font-weight: 900;
				font-size: 14px;
				color: #3C4353;
				border-bottom: solid 1px #D8D8D8;
				cursor: pointer;
				box-sizing: border-box;

				&.is-active {
					border-color: #337EFF;
					color: #337EFF;
					border-bottom: solid 1px #337EFF;
					box-sizing: border-box;
				}
			}
		}

		& > .main-list-cls {
			width: 100%;
			height: calc(100% - 45px - 36px - 28px - 24px - 66px);
			overflow-x: hidden;
			overflow-y: auto;

			& > .process-cell-cls {
				width: 100%;
				height: 56px;
				border-bottom: 1px dashed #D8D8D8;
				padding: 0 18px;
				line-height: 56px;
				box-sizing: border-box;

				& > .title-cls {
					width: calc(100% - 250px);
					line-height: 56px;
					display: inline-block;
					vertical-align: top;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					cursor: pointer;

					& .svg-icon {
						margin-right: 8px;
						cursor: pointer;
					}

					& > span {
						font-size: 14px;
						font-weight: 500;
						color: #3C4353;
					}

					& > i {
						display: inline-block;
						width: 38px;
						height: 18px;
						background: #FF5D5D;
						border-radius: 18px;
						text-align: center;
						font-size: 11px;
						color: #FFFFFF;
						vertical-align: top;
						margin-left: 8px;
						margin-top: 18px;
						line-height: 18px;
						font-style: normal;
						box-sizing: border-box;
					}
				}

				& > .btns-cls {
					height: 100%;
					float: right;
					text-align: right;

					& > .status-cls {
						display: inline-block;
						width: 50px;
						line-height: 18px;
						border-radius: 18px;
						font-size: 12px;
						color: #FF504D;
						margin-right: 12px;
						background: #FFECEC;
						border: 1px solid #FF504D;
						text-align: center;

						&.active {
							color: #47B267;
							border-color: #47B267;
							background: #F1FFF5;
						}
					}

					& > .click-cls {
						display: inline-block;
						width: 100px;
						font-size: 11px;
						font-weight: 400;
						color: #A6AAB8;
						line-height: 20px;
						text-align: left;

						& > i {
							font-style: normal;
							color: #337EFF;
							font-weight: bold;
						}
					}

					& .svg-icon {
						font-size: 16px;
						margin-right: 12px;
						color: #5A5A68;
						cursor: pointer;

						&:last-child {
							margin: 0;
						}
					}
				}
			}

			& > .know-cell-cls {
				width: 100%;
				height: 90px;
				border-bottom: 1px dashed #D8D8D8;
				padding: 12px 20px 8px;
				box-sizing: border-box;

				& > .header-cls {
					width: 100%;
					height: 20px;
					margin-bottom: 10px;

					& > .title-cls {
						width: calc(100% - 250px);
						line-height: 20px;
						display: inline-block;
						vertical-align: top;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						cursor: pointer;

						& .svg-icon {
							margin-right: 8px;
							cursor: pointer;
						}

						& > span {
							font-size: 14px;
							font-weight: 500;
							color: #3C4353;
						}

						& > i {
							display: inline-block;
							width: 38px;
							height: 18px;
							background: #FF5D5D;
							border-radius: 18px;
							text-align: center;
							font-size: 11px;
							color: #FFFFFF;
							vertical-align: top;
							margin-left: 8px;
							margin-top: 1px;
							line-height: 18px;
							font-style: normal;
							box-sizing: border-box;
						}
					}

					& > .btns-cls {
						height: 100%;
						float: right;
						text-align: right;

						& > .status-cls {
							display: inline-block;
							width: 50px;
							line-height: 18px;
							border-radius: 18px;
							font-size: 12px;
							color: #FF504D;
							margin-right: 12px;
							background: #FFECEC;
							border: 1px solid #FF504D;
							text-align: center;

							&.active {
								color: #47B267;
								border-color: #47B267;
								background: #F1FFF5;
							}
						}

						& > .click-cls {
							display: inline-block;
							width: 100px;
							font-size: 11px;
							font-weight: 400;
							color: #A6AAB8;
							line-height: 20px;
							text-align: left;

							& > i {
								font-style: normal;
								color: #337EFF;
								font-weight: bold;
							}
						}

						& .svg-icon {
							font-size: 16px;
							margin-right: 12px;
							color: #5A5A68;
							cursor: pointer;

							&:last-child {
								margin: 0;
							}
						}
					}
				}

				& > .describe-cls {
					width: calc(100% - 200px);
					height: 40px;
					font-size: 12px;
					font-weight: 400;
					color: #6C7E91;
					line-height: 20px;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			& > .pagination-cls {
				margin-top: 50px;
				width: 100%;
				text-align: center;
			}
		}
	}

	& > .modal-frame-cls {
		display: inline-block;
		width: 100%;
		height: 100%;
		overflow: hidden;
		transition: width .2s;
		border: none;
		border-left: solid 1px#dcdfe6;
		vertical-align: top;
		box-sizing: border-box;
		position: absolute;
		top: 0;
		right: 0;
		background: #fff;
		z-index: 10;

		&.main-width-cls {
			width: calc(100% - 300px);
			border-left: solid 1px #dcdfe6;
		}
	}
}
</style>